import api from './api';

export interface BugReportData {
  title: string;
  description: string;
  steps_to_reproduce?: string;
  browser?: string;
  page_url?: string;
  screenshot_url?: string;
  uploaded_images?: string[];
  additional_info?: Record<string, any>;
}

export interface BugReportResponse {
  id: number;
  /** Help Center request page for the new ticket. */
  url: string;
  title: string;
  status: string;
  created_at?: string;
  message: string;
}

export interface BugReportConfig {
  enabled: boolean;
}

const bugReportsService = {
  /**
   * Submit a bug report to Zendesk.
   *
   * Severity and priority are no longer collected — Zendesk agents triage
   * urgency during intake.
   */
  async submitBugReport(data: BugReportData): Promise<BugReportResponse> {
    const response = await api.post('/bug-reports/submit', data);
    return response.data;
  },

  /**
   * Get bug reporting configuration
   */
  async getConfig(): Promise<BugReportConfig> {
    const response = await api.get('/bug-reports/config');
    return response.data;
  }
};

export default bugReportsService;
